import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import energiswapTokens from '@energi/energiswap-default-token-list'
import PlaceHolder from '../../assets/images/Placeholder.svg'
import getEnvironmentVar from '../../utils/getEnvironmentVar'

const Inline = styled.div`
  display: flex;
  align-items: center;
  align-self: center;
`

const Image = styled.img`
  width: ${({ size }) => size};
  height: ${({ size }) => size};
  border-radius: 50%;
`

const chainId = parseInt(getEnvironmentVar('CHAIN_ID')) || 39797
const { tokens } = energiswapTokens
const tokenLogos = tokens?.filter((token) => token.chainId === chainId) ?? []
const BAD_IMAGES = {}

function getTokenLogoURL(address) {
  return address ? tokenLogos.find((token) => token.address.toLowerCase() === address.toLowerCase())?.logo : ''
}

export default function TokenLogo({ address, header = false, size = '24px', ...rest }) {
  const [error, setError] = useState(false)

  useEffect(() => {
    setError(false)
  }, [address])

  if (error || BAD_IMAGES[address]) {
    return (
      <Inline>
        <Image {...rest} alt={''} src={PlaceHolder} size={size} />
      </Inline>
    )
  }

  const icon = getTokenLogoURL(address) ? getTokenLogoURL(address) : PlaceHolder

  return (
    <Inline>
      <Image
        {...rest}
        alt={''}
        src={icon}
        size={size}
        onError={(event) => {
          BAD_IMAGES[address] = true
          setError(true)
          event.preventDefault()
        }}
      />
    </Inline>
  )
}
